export default "__VITE_ASSET__EOl762ZX__"